import { useFormHorarioClienteContext } from './Context';
import moment from 'moment';
import { convertMinutesToHHMM } from '../../../../components/utils';
import PriceInput from '../../../../components/inputs/Price';
import { describeRegra } from '../../../recorrencias/helpers';
import { capitalize, formatDuration, SummaryRow } from '../../booking/BookingParts';
import SelectClient from './SelectClient';

export const FormAgendamentoConfirmacao = () => {
    const {
        servico,
        servicosExtras,
        atendente,
        attendantCount,
        data,
        horario,
        setOpenConfirm,
        setShowHorarios,
        resetAttendant,
        valor,
        setValor,
        setPriceManual,
        observation,
        setObservation,
        observationClient,
        setObservationClient,
        doc,
        duration,
        recorrencia,
        recurrenceMode,
        lockAtendente,
        lockServico,
        subscriptionCovered,
    } = useFormHorarioClienteContext();
    const hasSubscription = Boolean(doc?.subscription);
    const services = [servico, ...servicosExtras].filter((item: any) => item?.name);

    return (
        <div className="space-y-5">
            <SelectClient />

            <div className="overflow-hidden rounded-2xl bg-base-100 ring-1 ring-base-content/[0.06]">
                <SummaryRow label="Data e horário" editLabel="Alterar data e horário" onEdit={() => setOpenConfirm(false)}>
                    {capitalize(moment(data).format('dddd, DD [de] MMMM'))} às {convertMinutesToHHMM(horario)}
                </SummaryRow>
                <SummaryRow
                    label={services.length > 1 ? 'Serviços' : 'Serviço'}
                    editLabel="Alterar serviços"
                    onEdit={lockServico ? undefined : () => {
                        setOpenConfirm(false);
                        setShowHorarios(false);
                    }}
                >
                    {services.map((item: any) => <div key={item?._id}>{item?.name}</div>)}
                    {!!duration && <div className="mt-0.5 text-sm font-normal text-base-content/60">{formatDuration(duration)}</div>}
                </SummaryRow>
                <SummaryRow
                    label="Profissional"
                    editLabel="Alterar profissional"
                    onEdit={!lockAtendente && (attendantCount || 0) > 1 ? () => {
                        setOpenConfirm(false);
                        resetAttendant();
                    } : undefined}
                >
                    {atendente?.displayName || '-'}
                </SummaryRow>
                {recurrenceMode && (
                    <SummaryRow label="Recorrência">
                        {describeRegra(recorrencia)}
                        <div className="mt-0.5 text-sm font-normal text-base-content/60">
                            {recorrencia.inicio ? moment(recorrencia.inicio).format('DD/MM/YYYY') : 'Início não definido'} até {recorrencia.fim ? moment(recorrencia.fim).format('DD/MM/YYYY') : 'fim não definido'}
                        </div>
                    </SummaryRow>
                )}
            </div>

            <PriceInput
                label="Valor total"
                value={!!valor ? valor.toString() : '0'}
                onChange={(e) => {
                    setValor(Number(e.target.value));
                    setPriceManual(true);
                }}
                placeholder="Valor total"
                disabled={hasSubscription || subscriptionCovered}
            />
            {subscriptionCovered && (
                <p className="-mt-3 text-sm text-base-content/60">Coberto pela assinatura do cliente.</p>
            )}

            <div className="grid gap-4 sm:grid-cols-2">
                <label className="block">
                    <span className="mb-2 block text-sm font-medium text-base-content/75">Observações internas</span>
                    <textarea
                        className="textarea textarea-bordered h-24 w-full rounded-2xl text-base sm:text-sm"
                        value={observation}
                        onChange={(e) => setObservation(e.target.value)}
                        placeholder="Observações para a equipe"
                    />
                </label>
                <label className="block">
                    <span className="mb-2 block text-sm font-medium text-base-content/75">Observação do cliente</span>
                    <textarea
                        className="textarea textarea-bordered h-24 w-full rounded-2xl text-base sm:text-sm"
                        value={observationClient}
                        onChange={(e) => setObservationClient(e.target.value)}
                        placeholder="Informações do cliente"
                    />
                </label>
            </div>
        </div>
    );
};
